import {useEffect} from "react";
import {useRouterActions} from "../../shared-services/redux-tiny";

// This hook is to temporarily fix the update the pageCode for special pages when the user is using the browser back/forward buttons
// When react component can react to location changes this can be removed and proper logic implemented
const usePopStatePageCode = () => {
  const {setPageCode} = useRouterActions();
  const handlePopState = (event) => {
    const currentPath = window.location.pathname;

    if (currentPath.includes("/ct")) {
      setPageCode("wordpress");
    } else if (currentPath.includes("/pl")) {
      setPageCode("pl");
    } else if (currentPath.includes("/kontakt")) {
      setPageCode("contact");
    } else if (["/agb", "/cgv", "/gtc"].some((path) => currentPath.includes(path))) {
      setPageCode("terms_and_conditions");
    }
  };

  useEffect(() => {
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
};

export default usePopStatePageCode;
